<template>
  <div :style="{ position: 'relative' }">
    <Loading
      :active.sync="loading"
      :isFullPage="false"
      :zIndex="9000"
    ></Loading>
    <Toast :style="{ width: $isMobile() ? '100vw' : '' }" />
    <Dialog
      id="'dialog-confirm-data'"
      :visible.sync="localShow"
      :style="{ width: $isMobile() ? '100vw' : '40vw' }"
      v-bind:class="[{ 'p-dialog-maximized': $isMobile() }]"
      :modal="true"
      :header="'Enviar solicitação para o cliente'"
    >
      <form name="validateForm" class="p-col-12" @submit.prevent="validate">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12" style="margin-top: 10px">
            <span class="p-float-label">
              <InputText
                v-model="client_contact"
                id="client_contact"
                name="client_contact"
              />
              <label for="client_contact">Contacto do Cliente</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-12" style="margin-top: 10px">
            <span class="p-float-label">
              <InputText
                v-model="client_email"
                id="client_email"
                name="client_email"
              />
              <label for="client_email">Email</label>
            </span>
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :label="'Enviar Solicitação'"
          icon="pi pi-envelope"
          class="p-button-success"
          @click="validate"
          :loading="loading"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="close"
          :disabled="loading"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import patService from "../../services/pat.service";

export default {
  name: "SendRequestEquipmentResources",
  props: ["show", "pat_id"],
  components: { Loading },
  data() {
    return {
      localShow: false,
      loading: false,
      client_email: null,
      client_contact: null
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        this.localShow = newVal;
        if (newVal) {
          this.onDialogOpen();
        }
      }
    },
    localShow(newVal) {
      if (!newVal && this.show) {
        this.$emit("close");
      }
    }
  },
  methods: {
    async onDialogOpen() {
      this.$nextTick(() => {
        this.errors.clear();
      });

      await this.getPatInfo();
    },

    reset() {
      this.client_email = null;
      this.client_contact = null;
      this.loading = false;
      this.errors.clear();
    },

    close() {
      this.reset();
      this.localShow = false;
    },

    async validate() {
      let isValid = false;

      if (this.client_email || this.client_contact) {
        isValid = true;
      }

      if (!isValid) {
        this.$toast.add({
          severity: "warn",
          summary: "Validação",
          detail: "Por favor, preencha o contacto ou email do cliente ou ambos",
          life: 3000,
        });
        return;
      }

      return this.saveRequest();
    },

    async getPatInfo() {
      this.loading = true;
      try {
        const response = await patService.getInfo(this.pat_id);

        if (!response) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao obter dados",
            detail: "Ocorreu um erro ao obter dados do PAT",
            life: 3000,
          });
          return;
        }

        if (Object.keys(response).includes('entity')) {
          if (response?.entity?.email) {
            this.client_email = response.entity.email.trim();
          }

          if (response?.entity?.tlmvl) {
            this.client_contact = response.entity.tlmvl.trim();
          } else if (response?.entity?.telephone) {
            this.client_contact = response.entity.telephone.trim();
          }
        } else {
          this.client_email = response.client.email.trim();

          if (response?.client?.mobilPhone) {
              this.client_contact = response.client.mobilPhone.trim();
          } else if (response?.client?.telephone) {
              this.client_contact = response.client.telephone.trim();
          }
        }

      } catch (error) {
        console.error('Error fetching PAT info:', error);
        this.$toast.add({
          severity: "error",
          summary: "Erro ao obter dados",
          detail: "Ocorreu um erro ao obter dados",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },

    async saveRequest() {
      this.loading = true;

      const data = {
        email: this.client_email,
        phone: this.client_contact
      };

      try {
        const response = await patService.sendRequestEquipmentResourcesToClient(this.pat_id, data);

        if (!response) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao enviar solicitação",
            detail: "Tente novamente mais tarde",
            life: 3000,
          });
          return;
        }

        for (const messageObj of response.messages) {
          if (messageObj.status === 'success') {
            this.$toast.add({
              severity: "success",
              summary: "Sucesso",
              detail: messageObj.message,
              life: 3000,
            });
          } else if (messageObj.status === 'error') {
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: messageObj.message,
              life: 3000,
            });
          }
        }

        this.$emit("sended", response);
        this.close();

      } catch (error) {
        console.error('Error sending:', error);
        this.$toast.add({
          severity: "error",
          summary: "Erro ao enviar solicitação",
          detail: "Tente novamente mais tarde",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.p-error {
  display: block;
  margin-top: 0.25rem;
}
</style>